<script setup>
import { computed, onMounted, reactive, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { usePersonalAccountDataState } from '../../utilities/account/useAccountDataPersonal'
import { useInvestmentProcessDataState } from '../../utilities/investment-process/useInvestmentProcess'
import { getAccountLink } from '../../utilities/useLinks'
import { useLegalAccountDataState } from '../../utilities/account/useAccountDataLegal'
import { isNaturalProfile } from '../../utilities/investment-process/useUserProfileType'

const { naturalProfile } = storeToRefs(usePersonalAccountDataState())
const { legalProfile } = storeToRefs(useLegalAccountDataState())
const { depotFields } = storeToRefs(useInvestmentProcessDataState())
const additionalFields = computed(() => window.campaign?.asset_data?.additional_fields ?? null)
const form = reactive({})

function editAdditionalFields() {
    window.location.href = getAccountLink() + '?menu=Verification&tab=depot'
}

onMounted(() => {
    if (additionalFields.value) {
        Object.keys(additionalFields.value).forEach((field) => {
            form[field] = isNaturalProfile() ? naturalProfile.value[field] : legalProfile.value[field] || ''
        })
    }
})

watch(
    form,
    () => {
        depotFields.value = { ...form }
    },
    { deep: true }
)
</script>

<template>
    <div
        v-if="additionalFields && Object.keys(additionalFields).length > 0"
        class="flex h-auto w-full flex-col items-start justify-start overflow-hidden rounded-md border border-gray-200">
        <div class="flex h-10 w-full items-center justify-between border-b border-gray-200 bg-gray-50 px-4 sm:px-8">
            <p class="text-sm font-bold text-gray-700">{{ $t('investment_process.depot_additional_fields') }}</p>
            <button class="text-sm text-gray-500 hover:text-gray-700" @click="editAdditionalFields">
                {{ $t('account_settings.edit') }}
            </button>
        </div>
        <div class="grid h-auto w-full grid-cols-2 gap-6 px-4 py-4 sm:px-8">
            <div
                v-for="field in Object.keys(additionalFields)"
                :key="field"
                class="col-span-1 flex h-auto flex-col items-start justify-start space-y-2">
                <label :for="field" class="text-sm font-medium text-gray-500">
                    {{ $t(`investment_process.${field}`) }}
                    <span class="text-red-500">{{ additionalFields[field].required ? '*' : '' }}</span>
                </label>
                <input
                    :id="field"
                    v-model="form[field]"
                    :name="field"
                    type="text"
                    class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 outline-none ring-0 focus:border focus:border-primary" />
            </div>
        </div>
    </div>
</template>
